import { FC } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { CompaniesPieColors } from 'slices/modules/companies/companiesPieColors';

interface Props {
  companies: PortfolioAnalyticsCompanyListItem[];
  pieColors: CompaniesPieColors;
}

const AnalyticsCompaniesPie: FC<Props> = ({ companies, pieColors }) => {
  const pieSize = 208;

  return (
    <PieChart width={pieSize} height={pieSize}>
      <Pie
        data={companies}
        dataKey="volumePercent"
        nameKey="ticker"
        innerRadius={pieSize / 2 - 30}
        outerRadius={pieSize / 2 }
      >
        {companies.map((entry, index) => (
          <Cell key={index} fill={pieColors[entry.name]} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default AnalyticsCompaniesPie;
